module.exports = __webpack_public_path__ + "static/media/CoachxMarvel_Module_bg.05fe1128.gif";